const t = {
  "rich-text": "rich-text",
  "rich-text--is-footnote": "rich-text--is-footnote",
  "rich-text--is-footer-type": "rich-text--is-footer-type"
};
export {
  t as default
};
